import { useState } from 'react';

import {
  StyledCard,
  CardHeaderStyled,
  AlertStyled,
} from 'pages/Orders/OrdersShow/OrdersShowCommonInfo/OrdersShowCommonInfo.styled';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ReferenceManyField, WithListContext } from 'react-admin';
import { Collapse } from 'shared/mui/Collapse/Collapse';
import { ExpandIconButton } from 'shared/mui/IconButtons';
import { DateTimeField, OrderStatusChipField, TextField } from 'shared/react-admin/Fields';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';

import { DatagridStyled } from './OrdersShowCommonInfoStatuses.styled';

export const OrdersShowCommonInfoStatuses = (): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(true);
  const translate = useTypedTranslate();

  const handleExpandClick = () => setIsExpanded(!isExpanded);

  return (
    <StyledCard>
      <CardHeaderStyled
        appendActions={
          <ExpandIconButton isExpanded={isExpanded} onClick={handleExpandClick} size="small" />
        }
        isExpanded={isExpanded}
        title={translate('app.orders.statuses.history')}
        titleSize="smallBold"
      />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <ReferenceManyField label={false} reference="order_status_histories" target="order">
          <WithListContext
            render={({ data, isLoading }) => {
              if (!data?.length && !isLoading) {
                return (
                  <AlertStyled severity="info">
                    {translate('app.orders.statuses.noStatuses')}
                  </AlertStyled>
                );
              }
              return (
                <DatagridStyled bulkActionButtons={false}>
                  <TextField label={translate('app.orders.statuses.statusId')} source="originId" />
                  <ReferenceField
                    label={translate('app.orders.statuses.orderStatus')}
                    reference="new/order_statuses"
                    source="status"
                  >
                    <OrderStatusChipField source="description" />
                  </ReferenceField>
                  <DateTimeField
                    label={translate('app.orders.statuses.changedAt')}
                    source="createdAt"
                  />
                </DatagridStyled>
              );
            }}
          />
        </ReferenceManyField>
      </Collapse>
    </StyledCard>
  );
};
